import React__default from 'react';
import { Context } from '@grandvisionhq/carts-v2';
import { PromoteInstallmentsLabel } from '@grandvisionhq/content';
import { PromoteInstallmentsModalSlot } from '@grandvisionhq/fun-products';
import { useIntl } from '@grandvisionhq/state';
import { formatPrice } from '@grandvisionhq/utils';
import { useProductDetailContext } from '../ProductDetail/Context/ProductDetailContext.js';

// this little helper will get the price
// activeVariant is for the PDP page: e.g. Slots.AfterPrice, Slots.AfterCTA
// cart is for the checkout page: e.g. Slots.AfterTotal
const getPrice = (priceType, activeVariant, cart)=>{
    // get price for PDP page
    if (priceType === 'item' && activeVariant) {
        var ref, ref1;
        var ref2;
        return (ref2 = (ref = activeVariant.price) === null || ref === void 0 ? void 0 : ref.discountedPrice) !== null && ref2 !== void 0 ? ref2 : (ref1 = activeVariant.price) === null || ref1 === void 0 ? void 0 : ref1.originalPrice;
    }
    // get price for checkout page
    if (priceType === 'cart' && cart) {
        return cart.prices.totalPrice;
    }
    // this value will make component not render at all
    return 0;
};
// when enabledProduct is undefined this component will render for every product type
// when enabledProduct is set e.g. ['sunglasses'] it will render ONLY for this product type
const getExcludedProductType = (enabledProductTypes, productType)=>{
    if (!enabledProductTypes || !productType) {
        return false;
    }
    return !enabledProductTypes.some((product)=>product.toLowerCase() === productType.toLowerCase()
    );
};
const PromoteInstallments = ({ siteLogos , numberOfInstallments , minimumPrice , priceType , productType , enabledProductTypes , textAlign  })=>{
    const { currency , locale  } = useIntl();
    const { activeVariant  } = useProductDetailContext();
    const { cart  } = Context.useCart();
    const price = getPrice(priceType, activeVariant, cart);
    const excludedProductType = getExcludedProductType(enabledProductTypes, productType);
    const isCentAmount = true;
    const installmentPrice = formatPrice({
        locale,
        value: price / numberOfInstallments,
        currency,
        isCentAmount
    });
    // conditions to render component
    if (price < minimumPrice || excludedProductType) {
        return null;
    }
    return /*#__PURE__*/ React__default.createElement(PromoteInstallmentsLabel, {
        installmentPrice: installmentPrice,
        numberOfInstallments: numberOfInstallments,
        textAlign: textAlign,
        modalBodySlot: /*#__PURE__*/ React__default.createElement(PromoteInstallmentsModalSlot, {
            siteLogos: siteLogos,
            price: price,
            isCentAmount: isCentAmount,
            numberOfInstallments: numberOfInstallments
        })
    });
};

export { PromoteInstallments };
//# sourceMappingURL=PromoteInstallments.js.map
